module.exports = __webpack_public_path__ + "img/pub_rec_home_final_mobile_600.93cf8117.png";